import { mapVideocallStatus } from 'utilities/video/videoStatusMapper';
const actionTypes = require('constants/actionTypes');
const Immutable = require('immutable');
const storage = require('utilities/storage');

const initialState = Immutable.Map({
    videoCallUrl: '',
    videoCallUrlLoaded: false,
    videoCallStatus: '',
    videoCallResult: false,
    method: '',
});

const identifyReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.VIDEO_CALL_URL:
            let url = action.data.url;
            const language = storage.cookies.get('language');
            url = url.replace(/"/g, '');
            url = `${url}&language=${language}`;

            return state.merge({
                videoCallUrl: url,
                videoCallUrlLoaded: true,
            });

        case actionTypes.VIDEO_CALL_STATUS:
            const status = mapVideocallStatus(action.data.status, param => {
                return param;
            });

            const method = action.data.method;
            let result = state.get('videoCallResult');

            if (status.length && status !== 'programmed' && status !== '16' && status != 'waiting' && status !== '') {
                result = true;
            }

            return state.merge({
                videoCallStatus: status,
                videoCallResult: result,
                method,
            });

        case actionTypes.VIDEO_CALL_RESET:
            return state.merge({
                videoCallUrl: '',
                videoCallUrlLoaded: false,
                videoCallStatus: '',
                videoCallResult: false,
                method: '',
            });

        default:
            return state;
    }
};

module.exports = identifyReducer;
